import React from 'react';
import { ListWrapper } from '@builtbypixel/nucleus';
import { Button, Badge, Text, Box, Flex } from '@builtbypixel/plasma';
import { Link } from 'react-router-dom';
import setup from './setup';

// Extra Menu appears next to the create button
const extraMenu = () => {
  return null;
};

const extraInfo = ({ stats }) => {
  return (stats.total_price || stats.meta?.total) ? (
    <Flex
      bg='global.elementBg'
      p='8px'
    >
      <Box mr={16}>
        <Text fontWeight={600}>Total</Text>
        <Text fontSize={24}>£{stats.total_price?.toFixed(2)}</Text>
      </Box>
      <Box>
        <Text fontWeight={600}>Count</Text>
        <Text fontSize={24}>{stats.meta.total}</Text>
      </Box>
    </Flex>
  ) : null;
};

const getStatusColour = (id) => {
  if (id === 5) {
    return 'grey';
  }
  if (id === 4) {
    return 'success';
  }
  if (id === 3) {
    return 'error';
  }
  if (id === 2) {
    return 'error';
  }
  if (id === 1) {
    return 'warning';
  }
};

const List = () => {
  const columns = [
    {
      Header: 'Order Number',
      accessor: 'id',
      Cell: ({ row }) => (
        <Link
          to={`${setup.model}/${
            row.original.purchase_order ? 'edit' : 'view'
          }/${row.original[setup.accessor]}`}
        >
          <Button variantColor='secondary' variant='link'>
            {row.original.id}
          </Button>
        </Link>
      ),
    },
    {
      Header: 'Order Reference',
      accessor: 'id933',
      Cell: ({ row }) => {
        return <Text>{row.original.reference}</Text>;
      },
    },
    {
      Header: 'Name',
      accessor: 'name',
    },

    {
      Header: 'Email',
      accessor: 'email',
    },
    {
      Header: 'PO Number',
      accessor: 'purchase_order',
      Cell: ({ row }) =>
        row.original.purchase_order ? (
          <Text>{row.original.purchase_order}</Text>
        ) : (
          'N/A'
        ),
    },
    {
      Header: 'Total',
      accessor: 'total',
      Cell: ({ row }) => {
        return <Text>£{row.original.price}</Text>;
      },
    },
    {
      Header: 'Order Status',
      accessor: 'order_status',
      Cell: ({ value }) => (
        <Badge variantColor={getStatusColour(value.id)}>{value.name}</Badge>
      ),
    },
    {
      Header: 'Created At',
      accessor: 'created_at',
    },
  ];

  const filters = [
    {
      component: 'text',
      label: 'PO Number',
      name: 'purchase_order',
      placeholder: 'Enter a PO Number',
    },
    {
      component: 'multiselect',
      options: [
        {
          id: 1,
          name: 'POA',
          value: 'poa',
        },
        {
          id: 2,
          name: 'Pallet',
          value: 'pallet',
        },
        {
          id: 3,
          name: 'Non Deliverable',
          value: 'non-deliverable',
        },
        {
          id: 4,
          name: 'Purchase Order',
          value: 'purchase-order',
        },
      ],
      labelKey: 'name',
      valueKey: 'id',
      name: 'status',
      placeholder: 'Status',
    },
    {
      component: 'date',
      name: 'from',
      placeholder: 'From',
    },
    {
      component: 'date',
      name: 'to',
      placeholder: 'To',
    },
  ];

  return (
    <ListWrapper
      setup={setup}
      columns={columns}
      extraMenu={extraMenu}
      extraInfo={extraInfo}
      filters={filters}
    />
  );
};

export default List;